module.exports = __webpack_public_path__ + "static/media/05.1c57cfe2.jpg";